// Module
var code = "<template> <div dt-grid-container> <h1>Legg til artikkel</h1> <require from=\"./article-create-form\"></require> <article-create-form article-saved.delegate=\"articleSaved()\"> <a dt-button route-href=\"route: article-index\">Tilbake til liste</a> </article-create-form> </div> </template>";
// Exports
export default code;